import { onMounted, ref } from "vue";
import { alertController, AlertOptions } from "@ionic/vue";

interface OverlayEventDetail<T = any> {
    data?: T;
    role?: string;
}

export function useAlert(alertOptions: AlertOptions) {
    const alert = ref<HTMLIonAlertElement | undefined>()
    const dismissData = ref<OverlayEventDetail>()

    const setup = async (): Promise<void> => {
        let cssClass = 'custom-alert '
        if (alertOptions.cssClass) {
            if (typeof alertOptions.cssClass === 'string') cssClass += alertOptions.cssClass
            else cssClass += (alertOptions.cssClass).join(' ')
        }

        delete alertOptions.cssClass

        alert.value = await alertController.create({
            ...alertOptions,
            cssClass: cssClass
        })

        alert.value.onDidDismiss().then((value) => {
            setup()
            dismissData.value = value
        })
    }

    onMounted(setup)

    return {
        present: () => alert.value?.present(),
        dismiss: (data?: any, role?: string | undefined) => alert.value?.dismiss(data, role),
        dismissData,
        alert
    }
}
